import createSvgIcon from "./utils/create_icon"

const CheckmarkLarge = createSvgIcon(<path clipRule="evenodd" d="M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0z" fill="currentColor" fillRule="evenodd" />, "CheckmarkLarge")
export default CheckmarkLarge
